<template lang="pug">
  .grouping-job-table.job
    JobTableRow(
      v-for="(v, i) in jobs",
      :job="v",
      :index="i",
      :key="v.id",
      :updateFavorForIndex="true",
      @display="display",
    )
</template>

<script>
  import JobTableRow from './JobTableRow'

  export default {
    components: {
      JobTableRow,
    },
    props: ['jobs'],
    methods: {
      display (id) {
        this.$emit('display', id)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/grouping-job/JobTable.vue